
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 66.91 122.88"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M64.96 111.2a6.884 6.884 0 01-.13 9.73 6.875 6.875 0 01-9.73-.14L1.97 66.01l4.93-4.8-4.95 4.8a6.902 6.902 0 01.15-9.76c.08-.08.16-.15.24-.22L55.1 2.09c2.65-2.73 7-2.79 9.73-.14 2.73 2.65 2.78 7.01.13 9.73L16.5 61.23l48.46 49.97z"}})])
          )
        }
      }
    